var map = {
	"./add-new-form-light.svg": "dec9",
	"./add-new-form.svg": "cc25",
	"./add-new-import-light.svg": "f5c1",
	"./add-new-import.svg": "79f7",
	"./add-new-send-light.svg": "ba9f",
	"./add-new-send.svg": "c54a",
	"./arrow-down.svg": "2e6e",
	"./arrow-right.svg": "3f8a",
	"./arrow-up.svg": "4ea0",
	"./chart.png": "3172",
	"./contact-email.svg": "8b4c",
	"./contact-phone.svg": "048b",
	"./empty-projects.svg": "c203",
	"./empty.svg": "0afe",
	"./icon-money.svg": "25b8",
	"./icon-project-details.svg": "3fae",
	"./icon-skills.svg": "0217",
	"./icon-team-members.svg": "e5c8",
	"./interview_rmcf.svg": "91b4",
	"./join.svg": "356b",
	"./login-form-img.svg": "d3e5",
	"./logo-full-dark.svg": "1e28",
	"./logo-full.svg": "0636",
	"./logo-syg-dark.svg": "4f99",
	"./logo-syg.svg": "b5d6",
	"./logo-typo-dark.svg": "a131",
	"./logo-typo.svg": "3f3b",
	"./slider-1.svg": "e265",
	"./slider-2.svg": "7531",
	"./slider-3.svg": "4638",
	"./slider-4.svg": "6e5a",
	"./survey-logo.svg": "269f",
	"./survey-thank-you-img.svg": "bc12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";